module.exports = __webpack_public_path__ + "img/candy-shop.c343566e.png";